import { mount } from 'svelte';

// The house look (`packages/shell/INTEGRATION.md` 3.6, path A): the shell's
// Nunito first, then every `--ui-*` token's default, then the house theme
// (pure black and pure white since shell 1.4.0, dark and light). The shell's
// values sit in cascade layers, so the game's own unlayered `app.css` wins
// over both whatever the order; it sets no `--ui-*` colour but the default
// accent, Interlock's signature blue (`docs/decisions/0056`, `0057`).
import '@artibens/app-shell/fonts.css';
import '@artibens/app-shell/tokens.css';
import '@artibens/app-shell/theme.css';
import './app.css';

import App from './App.svelte';

const target = document.getElementById('app');

if (target === null) {
  throw new Error('Interlock: mount target #app is missing from index.html');
}

export default mount(App, { target });
